export default "__VITE_ASSET__cf871ff1__"